/**
 * Speed Booster Pro — Upload to: Assets folder in Shopify Theme Editor
 * Version: 1.0
 */
(function () {
  'use strict';

  // ── 1. LAZY LOAD ALL IMAGES & IFRAMES ──────────────────────────────────────
  function lazyLoadImages() {
    document.querySelectorAll('img').forEach(function (img) {
      if (!img.getAttribute('loading')) {
        img.setAttribute('loading', 'lazy');
      }
    });
    document.querySelectorAll('iframe').forEach(function (frame) {
      if (!frame.getAttribute('loading')) {
        frame.setAttribute('loading', 'lazy');
      }
    });
  }

  // ── 2. PREFETCH PAGES ON LINK HOVER (instant navigation feel) ─────────────
  function instantPage() {
    var prefetched = new Set();

    document.querySelectorAll('a[href]').forEach(function (link) {
      var href = link.href;

      // Skip external links, cart, checkout, account
      if (
        !href ||
        href.indexOf(window.location.origin) !== 0 ||
        href.indexOf('/cart') !== -1 ||
        href.indexOf('/checkout') !== -1 ||
        href.indexOf('/account') !== -1 ||
        href === window.location.href
      ) return;

      link.addEventListener('mouseover', function () {
        if (prefetched.has(href)) return;
        prefetched.add(href);
        var el = document.createElement('link');
        el.rel = 'prefetch';
        el.href = href;
        document.head.appendChild(el);
      }, { once: true });
    });
  }

  // ── 3. DEFER NON-CRITICAL THIRD-PARTY SCRIPTS ──────────────────────────────
  function deferScripts() {
    var DEFER_LIST = [
      'tidio', 'intercom', 'drift', 'crisp', 'tawk',
      'hotjar', 'clarity', 'mouseflow',
      'connect.facebook.net', 'fbevents',
      'static.klaviyo', 'cdn.klaviyo',
      'zendesk', 'freshworks',
      'twitter', 'pinterest'
    ];

    document.querySelectorAll('script[src]').forEach(function (s) {
      var src = s.src.toLowerCase();
      var shouldDefer = DEFER_LIST.some(function (kw) {
        return src.indexOf(kw) !== -1;
      });
      if (shouldDefer && !s.defer && !s.async) {
        var ns = document.createElement('script');
        ns.src = s.src;
        ns.defer = true;
        s.parentNode && s.parentNode.replaceChild(ns, s);
      }
    });
  }

  // ── 4. ADD DNS PREFETCH RESOURCE HINTS ────────────────────────────────────
  function resourceHints() {
    var hints = [
      { rel: 'preconnect',   href: 'https://cdn.shopify.com', co: true },
      { rel: 'dns-prefetch', href: '//cdn.shopify.com' },
      { rel: 'dns-prefetch', href: '//fonts.googleapis.com' },
      { rel: 'dns-prefetch', href: '//fonts.gstatic.com' },
      { rel: 'dns-prefetch', href: '//www.googletagmanager.com' },
      { rel: 'dns-prefetch', href: '//connect.facebook.net' },
      { rel: 'dns-prefetch', href: '//static.klaviyo.com' }
    ];

    hints.forEach(function (h) {
      if (document.querySelector('link[href="' + h.href + '"]')) return;
      var el = document.createElement('link');
      el.rel = h.rel;
      el.href = h.href;
      if (h.co) el.setAttribute('crossorigin', '');
      document.head.appendChild(el);
    });
  }

  // ── 5. PRELOAD HERO IMAGE ──────────────────────────────────────────────────
  function preloadHero() {
    var hero = document.querySelector(
      '.hero img, .banner img, .slideshow img, ' +
      '[class*="hero"] img:first-child, ' +
      '[class*="slideshow"] img:first-child, ' +
      'section:first-of-type img:first-child'
    );
    if (!hero || !hero.src) return;
    if (document.querySelector('link[rel="preload"][as="image"]')) return;

    var link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = hero.src;
    document.head.insertBefore(link, document.head.firstChild);
  }

  // ── 6. FONT DISPLAY SWAP ───────────────────────────────────────────────────
  function fontSwap() {
    var style = document.createElement('style');
    style.textContent = '@font-face { font-display: swap; } * { -webkit-font-smoothing: antialiased; }';
    document.head.appendChild(style);
  }

  // ── 7. DEFER OFFSCREEN VIDEOS ─────────────────────────────────────────────
  function deferVideos() {
    document.querySelectorAll('video').forEach(function (v) {
      var rect = v.getBoundingClientRect();
      var inView = rect.top < window.innerHeight && rect.bottom > 0;
      if (!inView) v.setAttribute('preload', 'none');
    });
  }

  // ── RUN ────────────────────────────────────────────────────────────────────
  function run() {
    resourceHints();
    lazyLoadImages();
    preloadHero();
    fontSwap();
    deferVideos();

    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () {
        instantPage();
        deferScripts();
      });
    } else {
      setTimeout(function () {
        instantPage();
        deferScripts();
      }, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

})();
